import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Bell, Calendar, AlertCircle, CheckCircle, Info } from 'lucide-react';

const announcements = [
  {
    id: 1,
    type: 'info',
    title: 'New Buyer Agency Guidelines Now in Effect',
    message: 'Important updates regarding buyer agency agreements and compensation disclosures. Please review the updated guidelines in the Resources section.',
    date: '2 days ago',
    isNew: true
  },
  {
    id: 2,
    type: 'success',
    title: 'Annual Conference Registration Open',
    message: 'Early bird registration for the 2024 AREA National Conference is now open. Members receive 20% off registration fees.',
    date: '3 days ago',
    isNew: true
  },
  {
    id: 3,
    type: 'alert',
    title: 'System Maintenance Scheduled',
    message: 'The member portal will be briefly unavailable on Saturday, Dec 28 from 2-4 AM EST for scheduled maintenance.',
    date: '5 days ago',
    isNew: false
  },
  {
    id: 4,
    type: 'info',
    title: 'New Partnership Announcement',
    message: 'AREA is proud to announce our new strategic partnership with HomeTitle Insurance Co., bringing exclusive benefits to all members.',
    date: '1 week ago',
    isNew: false
  },
  {
    id: 5,
    type: 'success',
    title: 'Membership Milestone Reached',
    message: 'We\'re thrilled to welcome our 20,000th member! Thank you for being part of the AREA community.',
    date: '2 weeks ago',
    isNew: false
  }
];

const getIcon = (type) => {
  switch (type) {
    case 'success': return CheckCircle;
    case 'alert': return AlertCircle;
    default: return Info;
  }
};

const getIconColor = (type) => {
  switch (type) {
    case 'success': return 'text-green-600 bg-green-100';
    case 'alert': return 'text-yellow-600 bg-yellow-100';
    default: return 'text-blue-600 bg-blue-100';
  }
};

export default function DashboardAnnouncements() {
  return (
    <div className="space-y-8" data-testid="dashboard-announcements">
      <div>
        <h1 className="font-heading text-2xl font-bold text-slate-900">Announcements</h1>
        <p className="text-slate-600">Stay updated with the latest AREA news and updates</p>
      </div>

      <div className="space-y-4">
        {announcements.map((announcement) => {
          const Icon = getIcon(announcement.type);
          const iconColor = getIconColor(announcement.type);
          
          return (
            <Card 
              key={announcement.id} 
              className={`border shadow-lg transition-all duration-300 ${
                announcement.isNew ? 'border-[#3D4F7A] bg-[#3D4F7A]/5' : 'border-slate-200'
              }`}
            >
              <CardContent className="p-6">
                <div className="flex gap-4">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${iconColor}`}>
                    <Icon className="w-5 h-5" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-start justify-between gap-4">
                      <div>
                        <h3 className="font-semibold text-slate-900 flex items-center gap-2">
                          {announcement.title}
                          {announcement.isNew && (
                            <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-[#D42B3C] text-white">
                              New
                            </span>
                          )}
                        </h3>
                        <p className="text-slate-600 text-sm mt-1">{announcement.message}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2 mt-3 text-xs text-slate-500">
                      <Calendar className="w-3 h-3" />
                      {announcement.date}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
